import { Navigate, useLocation } from "react-router-dom";

function getRoleFromToken() {
  const t = localStorage.getItem("dealerToken");
  if (!t) return null;
  const parts = t.split(".");
  if (parts.length !== 3) return null;
  try {
    const payload = JSON.parse(
      atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"))
    );
    return (
      payload.role ||
      payload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] ||
      null
    );
  } catch {
    return null;
  }
}

export default function RequireDealer({ children, roles = [] }) {
  const token = localStorage.getItem("dealerToken");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/dealer/login" replace state={{ from: location }} />;
  }

  const role = getRoleFromToken();

  // If allowed roles are passed in, enforce them
  if (roles.length > 0 && !roles.includes(role)) {
    return <Navigate to="/dealer/leads" replace />;
  }

  return children;
}
